import React from 'react';
import { Form, Input, Select } from 'antd';

function CaseForm({ form }) {
  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="number"
        label="ลำดับ"
        rules={[{ required: true, message: "กรุณาระบุลำดับ" }]}
      >
        <Input />
      </Form.Item>
      
      <Form.Item
        name="case_name"
        label="Case Name"
        rules={[{ required: true, message: "กรุณาระบุชื่อ Case" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="remark"
        label="หมายเหตุ"
        rules={[{ required: true, message: "กรุณาระบุหมายเหตุ" }]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
}

export default CaseForm; 